import service from '@/services/SICUDgpd_resul_est';

export default {
  namespaced: true,

  actions: {
    /**
     * Petición para obtener labels registrados en Integrity que serán utilizados en una vista.
     */
    async update({ dispatch, rootGetters }) {
      return new Promise((resolve, reject) => {
        const payload = {
          dsSICUDgpd_resul_est: {
            eeDatos: [rootGetters['auth/state']],
            eegpd_resul_est: [
              {
                doc_num: rootGetters['SICUDgpd_est_crd/state'].numberDocument || 0, // default,
                ter_nit: rootGetters['SICUDgpd_est_crd/state'].nit,
              },
            ],
          },
        };

        let notification;

        service
          .update(payload)
          .then((response) => {
            const data = response.data.dsSICUDgpd_resul_est;

            if (data.eeEstados[0].Returnid === 0) {
              resolve(data.eegpd_resul_est[0]);
            } else if (data.eeEstados[0].Returnid === 98) {
              resolve([]);
            } else {
              notification = {
                code: data.eeEstados[0].Returnid,
                message: data.eeEstados[0].Estado,
                timestamp: Date.now(),
                type: 'error',
              };

              throw notification;
            }
          })
          .catch((error) => {
            if (error.type === undefined) {
              notification = {
                code: undefined,
                message: error.message,
                timestamp: Date.now(),
                type: 'error',
              };
            }

            dispatch('notification/create', notification, {
              root: true,
            });

            reject(notification);
          });
      });
    },
  },
};
